import ProductCard from '../product/ProductCard';
import PaginationBottomTable from '../table/common/PaginationBottomTable';
import { IPaginationTable } from '../table/common/interfaces/IPaginationTable';
import { isFavouriteProduct } from '../utils/utils';
import ProductUnavailableCard from './B2BProductUnavailableCard';

import { HaggleInvite } from '@/interfaces/api/invite/IInvite';
import { INotifications } from '@/interfaces/api/notifications/INotifications';
import { ICollectionProduct } from '@/interfaces/api/product/ICollectionProduct';
import { ProductCardType } from '@/interfaces/notifications/Notifications';

type B2BProductListProps = {
	collectionProduct: ICollectionProduct | null;
	paginationOption: IPaginationTable;
	favouriteMerchants?: INotifications[];
	type?: ProductCardType;
	refetchFavourites?: () => void;
	invitedUsers: HaggleInvite[];
	isPrivateB2BMarketplace?: boolean;
	refetchUserInvites: () => void;
};

const B2BProductList = ({
	collectionProduct,
	paginationOption,
	favouriteMerchants,
	type = ProductCardType.Store,
	refetchFavourites,
	isPrivateB2BMarketplace,
}: B2BProductListProps) => {
	return (
		<div className="w-full py-4  sm:py-5 px-5" data-test="product-list">
			<h2 className="text-xl font-bold text-gray-900">
				{isPrivateB2BMarketplace
					? 'Private Products in Haggle'
					: 'Products in Haggle'}
			</h2>

			{collectionProduct && collectionProduct.data.length > 0 ? (
				<div className="my-8 grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-6 xl:gap-x-8">
					{collectionProduct.data.map((product, index) => {
						const isFavourite = isFavouriteProduct(product, favouriteMerchants);

						if ('id' in product && 'title' in product) {
							return (
								<div key={product.id + index} className="relative">
									<ProductCard
										productImageAlt={product.title}
										productImageSrc={product.images?.[0]?.src}
										productName={product.title}
										productVendor={product.vendor}
										productTradeName={product.tradeName}
										productPrice={product.variants[0].price}
										productHref={product.url ?? ''}
										productHaggle={product.haggle}
										cardType={type}
										isFavourite={isFavourite}
										notificationRequiredInfo={{
											haggleStartDate: product.haggle?.startDate,
											haggleEventId: product.haggle?.id,
											productId: product.id,
											productName: product.title,
											productUrl: product.url ?? '',
											sent: false,
										}}
										refetchFavourites={refetchFavourites}
									/>
								</div>
							);
						} else {
							return (
								<ProductUnavailableCard
									key={product.productId || index}
									tradeName={product.tradeName}
									productId={product.productId}
								/>
							);
						}
					})}
				</div>
			) : (
				<div className="flex justify-center items-center h-40 text-gray-500 text-lg">
					No Products found!
				</div>
			)}

			{paginationOption && <PaginationBottomTable {...paginationOption} />}
		</div>
	);
};

export default B2BProductList;
